import { useRef } from 'react';
import { FiSearch } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const SearchInput = ({ id, name, placeholder, className, onSearch, width, defaultValue }) => {
  const { t } = useTranslation();
  const search_input = useRef(null);

  const onSubmit = e => {
    e.preventDefault();

    const value = search_input.current.value;

    if (typeof onSearch === 'function') {
      onSearch(value);
    }
  };

  const classNames = ['search-input', className];

  return (
    <div className="d-flex align-items-center search-container">
      <div>
        <FiSearch size={22} />
      </div>
      <form onSubmit={onSubmit} width={width} className="flex-fill ms-2">
        <input
          type="search"
          ref={search_input}
          defaultValue={defaultValue}
          placeholder={placeholder || t('actions.search')}
          id={id}
          name={name}
          className={classNames.join(' ')}
          autoComplete="off"
        />
      </form>
    </div>
  );
};

export default SearchInput;
